import translate from '@allesauto/i18n';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import contactC2cSchema from '../validation/contactC2CSchema';
import contactDealerSchema from '../validation/contactDealerSchema';

export const useTranslationContactDealer = () => {
  const intl = useIntl();

  const memoizedContactDealerFormTranslations = useMemo(
    () => ({
      TITLE: translate(intl, 'ui.FORMS.CONTACT_DEALER.TITLE'),
      USER_MSG_LABEL: translate(intl, 'ui.FORMS.CONTACT_DEALER.USER_MSG_LABEL'),
      EMAIL_LABEL: translate(intl, 'ui.FORMS.CONTACT_DEALER.EMAIL'),
      EMAIL_RADIO_LABEL: translate(
        intl,
        'ui.FORMS.CONTACT_DEALER.EMAIL_RADIO_LABEL'
      ),
      CALL_BACK_LABEL: translate(
        intl,
        'ui.FORMS.CONTACT_DEALER.CALL_BACK_LABEL'
      ),
      VIDEO_CALL_LABEL: translate(
        intl,
        'ui.FORMS.CONTACT_DEALER.VIDEO_CALL_LABEL'
      ),
      REQUEST_LABEL: translate(intl, 'ui.FORMS.CONTACT_DEALER.REQUEST_LABEL'),
      FIRST_NAME: translate(intl, 'ui.FORMS.CONTACT_DEALER.FIRST_NAME'),
      LAST_NAME: translate(intl, 'ui.FORMS.CONTACT_DEALER.LAST_NAME'),
      PHONE: translate(intl, 'ui.FORMS.CONTACT_DEALER.PHONE'),
      TIMEWINDOW: translate(intl, 'ui.FORMS.CONTACT_DEALER.TIMEWINDOW'),
      REQUEST_TYPE_INFO_TEXT: translate(
        intl,
        'ui.FORMS.CONTACT_DEALER.REQUEST_TYPE_INFO_TEXT'
      ),
      DATE_PLACEHOLDER_TEXT: translate(
        intl,
        'ui.FORMS.CONTACT_DEALER.DATE_PLACEHOLDER_TEXT'
      ),
      REQUIRED_FIELD_NOTE: translate(
        intl,
        'ui.FORMS.COMMON.REQUIRED_FIELD_NOTE'
      ),
      BUTTON_TEXT: translate(intl, 'ui.FORMS.CONTACT_DEALER.BUTTON_TEXT'),
    }),
    [intl]
  );

  const memoizedContactC2CFormTranslations = useMemo(
    () => ({
      MESSAGE: translate(intl, 'ui.FORMS.CONTACT_C2C.MESSAGE'),
    }),
    [intl]
  );

  const memoizedContactDealerFormSchema = useMemo(() => {
    const validationMsgs = {
      lastName: {
        format: translate(
          intl,
          'ui.FORMS.VALIDATION_MESSAGES.STRING.ONLY_LETTERS'
        ),
        required: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.REQUIRED'),
        minLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MIN'),
        maxLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MAX'),
      },
      firstName: {
        format: translate(
          intl,
          'ui.FORMS.VALIDATION_MESSAGES.STRING.ONLY_LETTERS'
        ),
        required: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.REQUIRED'),
        minLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MIN'),
        maxLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MAX'),
      },
      email: {
        format: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.EMAIL'),
        required: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.REQUIRED'),
      },
      requestType: {
        required: translate(intl, 'ui.FORMS.CONTACT_DEALER.REQUEST_TYPE_MSG'),
      },
      phone: {
        required: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.REQUIRED'),
        minLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MIN'),
        maxLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MAX'),
      },
      requestDate: {
        required: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.REQUIRED'),
      },
      timeWindow: {
        required: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.REQUIRED'),
      },
    };
    return contactDealerSchema(validationMsgs);
  }, [intl]);

  const memoizedContactC2cFormSchema = useMemo(() => {
    const validationMsgs = {
      lastName: {
        format: translate(
          intl,
          'ui.FORMS.VALIDATION_MESSAGES.STRING.ONLY_LETTERS'
        ),
        required: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.REQUIRED'),
        minLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MIN'),
        maxLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MAX'),
      },
      firstName: {
        format: translate(
          intl,
          'ui.FORMS.VALIDATION_MESSAGES.STRING.ONLY_LETTERS'
        ),
        required: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.REQUIRED'),
        minLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MIN'),
        maxLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MAX'),
      },
      email: {
        format: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.EMAIL'),
        required: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.REQUIRED'),
      },
    };
    return contactC2cSchema(validationMsgs);
  }, [intl]);

  return {
    memoizedContactDealerFormTranslations,
    memoizedContactDealerFormSchema,
    memoizedContactC2cFormSchema,
    memoizedContactC2CFormTranslations,
  };
};

export default useTranslationContactDealer;
